import * as angular from 'angular';
import { RegentsPlanningStepperComponent } from './regents-planning-stepper.component';
import { CulminatingCourseStepComponent } from './steps/culminating-course/culminating-course.component';
import { ExamLoadStepComponent } from './steps/exam-load/exam-load.component';
import { GradPlansStepComponent } from './steps/grad-plans/grad-plans.component';
import { InstructionsStepComponent } from './steps/instructions/instructions.component';
import { OnTrackRegentsStepComponent } from './steps/on-track-regents/on-track-regents.component';
import { PlanPastDueExamsStepComponent } from './steps/plan-past-due-exams/plan-past-due-exams.component';
import { PriorityGroupStepComponent } from './steps/priority-group/priority-group.component';
import { ReadinessElaStepComponent } from './steps/readiness-ela/readiness-ela.component';
import { ReadinessMathStepComponent } from './steps/readiness-math/readiness-math.component';
import { RegentsExportStepComponent } from './steps/regents-export/regents-export.component';
import { StarsMismatchStepComponent } from './steps/stars-mismatch/stars-mismatch.component';

export const RegentsPlanningStepperModule = angular
  .module('regentsPlanningStepperModule', [])
  .component('regentsPlanningStepper', RegentsPlanningStepperComponent)
  .component('instructionStep', InstructionsStepComponent)
  .component('gradPlansStep', GradPlansStepComponent)
  .component('onTrackRegentsStep', OnTrackRegentsStepComponent)
  .component('starsMismatchStep', StarsMismatchStepComponent)
  .component('culminatingCourseStep', CulminatingCourseStepComponent)
  .component('priorityGroupStep', PriorityGroupStepComponent)
  .component('readinessElaStep', ReadinessElaStepComponent)
  .component('readinessMathStep', ReadinessMathStepComponent)
  .component('regentsExportStep', RegentsExportStepComponent)
  .component('examLoadStep', ExamLoadStepComponent)
  .component('planPastDueExamsStep', PlanPastDueExamsStepComponent).name;
